
export const supportNav = [
    {url: '/support', label: 'Support & Ticket', key: 'support.index', permissions: []},
    {url: '/support/create', label: 'Create ticket', key: 'support.ticket.create', parent_key: 'support.index', permissions: []},
    {url: '/support/[id]', label: '[id] Ticket', key: 'support.ticket', parent_key: 'support.index', permissions: []},
]